const e = {
  xxxl: "font-family-display font-weight-bolder leading-reset text-size-400 tracking-tighter",
  xxl: "font-family-display font-weight-bolder leading-reset text-size-300 tracking-tight",
  xl: "font-family-display font-weight-bolder leading-275 text-size-250 tracking-tight",
  lg: "font-family-display font-weight-bolder leading-225 text-size-200 tracking-tight",
  md: "font-family-display font-weight-bolder leading-175 text-size-150 tracking-tight",
  sm: "font-family-display font-weight-bolder leading-150 text-size-125 tracking-tight",
  xs: "font-weight-bold leading-125 text-size-100",
  xxs: "font-weight-bolder leading-75 text-size-62 tracking-wide uppercase"
}, t = {
  xxl: "leading-175 text-size-150 tracking-tight",
  xl: "leading-125 text-size-112",
  lg: "leading-125 text-size-100",
  md: "leading-100 text-size-87",
  sm: "leading-100 text-size-75",
  xs: "font-weight-bold leading-75 text-size-62 tracking-wider uppercase",
  xxs: "font-weight-bold leading-75 text-size-56 tracking-wider uppercase"
}, i = {
  lgLead: "leading-200 text-size-125",
  lg: "leading-150 text-size-100",
  mdLead: "leading-175 text-size-112",
  md: "leading-125 text-size-87",
  smLead: "leading-150 text-size-100",
  sm: "leading-100 text-size-75"
};
export {
  e as headingStyles,
  t as labelStyles,
  i as textStyles
};
